import { MDXRemote } from "next-mdx-remote";
import { useCallback, useEffect, useState } from "react";
import { convertMDX } from "utils/mdx";

import styles from "@/styles/basic-text.module.scss";

const BasicText = ({ data }) => {
  const textAlign = data.textAlign === "left" ? "text-left" : "text-center";
  const [state, setState] = useState(null);
  const setMDX = useCallback(async source => {
    const mdxSource = await convertMDX(source, false);
    setState(mdxSource);
  }, []);

  useEffect(() => {
    setMDX(data.content.replace("<br>", " "));
  }, [data.content, setMDX]);

  return (
    <section className="py-14 px-5 md:px-20 md:pb-20 md:pt-10">
      {state === null ? null : (
        <div
          className={`${textAlign} ${styles.content} ${
            textAlign === "text-left" ? "max-w-[870px]" : "max-w-[587px]"
          }`}
        >
          <MDXRemote {...state} />
        </div>
      )}
    </section>
  );
};

export default BasicText;
